import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Check } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { pricingPlans } from '../../data/mock';
import { Button } from '../ui/button';

const Pricing = ({ showHeader = true }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <section id="pricing" className="py-24 px-4 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        {showHeader && (
          <div className="text-center mb-16">
            <p className="text-emerald-600 font-semibold mb-4">{t('landing.pricing.eyebrow')}</p>
            <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
              {t('landing.pricing.title')}
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              {t('landing.pricing.subtitle')}
            </p>
          </div>
        )}

        {/* Pricing cards */}
        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {pricingPlans.map((plan) => {
            const tr = t(`landing.plans.${plan.id}`, { returnObjects: true });

            return (
              <div
                key={plan.id}
                className={`relative rounded-2xl p-8 ${
                  plan.popular
                    ? 'bg-white border-2 border-emerald-500 shadow-xl'
                    : 'bg-white border border-gray-200 shadow-lg'
                }`}
              >
                {plan.popular && (
                  <div className="absolute -top-4 left-1/2 -translate-x-1/2">
                    <span className="bg-gradient-to-r from-emerald-500 to-teal-500 text-white text-sm font-medium px-4 py-1 rounded-full">
                      {t('landing.pricing.popular_badge')}
                    </span>
                  </div>
                )}

                <div className="text-center mb-8">
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">{tr.name}</h3>
                  <p className="text-gray-500 text-sm mb-4">{tr.description}</p>
                  <div className="flex items-baseline justify-center gap-1">
                    <span className="text-4xl font-bold text-gray-900">
                      ${plan.price}
                    </span>
                    <span className="text-gray-500">{t('landing.pricing.per_month')}</span>
                  </div>
                </div>

                <ul className="space-y-4 mb-8">
                  {tr.features.map((feature, index) => (
                    <li key={index} className="flex items-start gap-3">
                      <div className="w-5 h-5 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                        <Check className="w-3 h-3 text-green-600" />
                      </div>
                      <span className="text-gray-600 text-sm">{feature}</span>
                    </li>
                  ))}
                </ul>

                <Button
                  variant={plan.popular ? 'default' : 'outline'}
                  className="w-full"
                  onClick={() => navigate('/register')}
                >
                  {tr.cta}
                </Button>
              </div>
            );
          })}
        </div>

        {/* Enterprise note */}
        <p className="text-center text-gray-500 mt-8">
          {t('landing.pricing.custom_question')}{' '}
          <a href="#" className="text-emerald-600 hover:underline">
            {t('landing.pricing.custom_link')}
          </a>
        </p>
      </div>
    </section>
  );
};

export default Pricing;
